import { api } from '../../shared/api/client';
import { adaptSavedLocation } from '../../shared/api/adapters';
import type { ApiSavedLocation } from '../../shared/types/api';
import type { SavedLocation } from '../../shared/types/app';

export async function fetchSavedLocations(): Promise<SavedLocation[]> {
  const res = await api.get<ApiSavedLocation[] | { data: ApiSavedLocation[] }>('/api/v1/users/me/locations');
  const list = Array.isArray(res) ? res : res.data;
  return list.map(adaptSavedLocation);
}

export async function addSavedLocation(loc: {
  label: string;
  address: string;
  lat?: number | null;
  lng?: number | null;
}): Promise<SavedLocation> {
  const res = await api.post<ApiSavedLocation>('/api/v1/users/me/locations', loc);
  return adaptSavedLocation(res);
}

export async function deleteSavedLocation(id: string) {
  return api.delete(`/api/v1/users/me/locations/${id}`);
}
